
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lmaeY", function(module, exports) {

$parcel$export(module.exports, "register", () => $f8c39898bb72a50d$export$6503ec6e8aabbaf, (v) => $f8c39898bb72a50d$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $f8c39898bb72a50d$export$f7ad0328861e2f03, (v) => $f8c39898bb72a50d$export$f7ad0328861e2f03 = v);
var $f8c39898bb72a50d$export$6503ec6e8aabbaf;
var $f8c39898bb72a50d$export$f7ad0328861e2f03;
"use strict";
var $f8c39898bb72a50d$var$mapping = new Map();
function $f8c39898bb72a50d$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f8c39898bb72a50d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f8c39898bb72a50d$var$resolve(id) {
    var resolved = $f8c39898bb72a50d$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f8c39898bb72a50d$export$6503ec6e8aabbaf = $f8c39898bb72a50d$var$register;
$f8c39898bb72a50d$export$f7ad0328861e2f03 = $f8c39898bb72a50d$var$resolve;

});

parcelRegister("9I1gl", function(module, exports) {

$parcel$export(module.exports, "globalLogger", () => $1eddc05c4e1b2852$export$90990fedfc4ff8f4);
$parcel$export(module.exports, "globalVersion", () => $1eddc05c4e1b2852$export$1cff41e9a1c10268);

var $k6Z8k = parcelRequire("k6Z8k");

var $5IvUh = parcelRequire("5IvUh");

var $jRama = parcelRequire("jRama");

var $4e7wm = parcelRequire("4e7wm");

var $2Xgi8 = parcelRequire("2Xgi8");

var $eyg9v = parcelRequire("eyg9v");

var $k4cEx = parcelRequire("k4cEx");
parcelRequire("7XkqE");
let $1eddc05c4e1b2852$var$finishedThisModule = false;
// this is all a bit tricky, I had it a few times that the serviceworker kept serving broken code which prohibited
// started including installing a new service worker
// 1234
const $1eddc05c4e1b2852$var$setupServiceWorkerWatchdog = ()=>{
    setTimeout(()=>{
        if (!$1eddc05c4e1b2852$var$finishedThisModule) {
            console.error("Module load timeout reached");
            if ("serviceWorker" in navigator) {
                console.log("Unregistering service worker");
                navigator.serviceWorker.getRegistrations().then((registrations)=>{
                    registrations.forEach((registration)=>{
                        registration.unregister().then((unregistered)=>{
                            console.log(`Unregistered service worker: ${unregistered}`);
                        });
                    });
                });
            }
        }
    }, 30000);
};
if ((0, $k6Z8k.Capacitor).isNativePlatform()) // Display content under transparent status bar
(async ()=>{
    try {
        await (0, $k4cEx.StatusBar).setOverlaysWebView({
            overlay: true
        });
        await (0, $k4cEx.StatusBar).hide();
        await (0, $5IvUh.ScreenOrientation).lock({
            orientation: "portrait"
        });
    } catch (e) {
        console.error("Error setting status bar overlay:", e);
    }
})();
const $1eddc05c4e1b2852$var$onScreenLogEnabled = false;
let $1eddc05c4e1b2852$var$onScreenLog = null;
if ($1eddc05c4e1b2852$var$onScreenLogEnabled) {
    const onScreenLogEl = document.createElement("div");
    onScreenLogEl.id = "on-screen-log";
    document.body.appendChild(onScreenLogEl);
    $1eddc05c4e1b2852$var$onScreenLog = new (0, $2Xgi8.HtmlConsoleLogger)("on-screen-log", 200);
}
const $1eddc05c4e1b2852$export$90990fedfc4ff8f4 = $1eddc05c4e1b2852$var$onScreenLog ? new (0, $jRama.LoggerImpl)([
    new (0, $4e7wm.BrowserConsoleLogger)(),
    $1eddc05c4e1b2852$var$onScreenLog
]) : new (0, $jRama.LoggerImpl)([
    new (0, $4e7wm.BrowserConsoleLogger)()
]);
$1eddc05c4e1b2852$export$90990fedfc4ff8f4.info("Logger initialized");
$1eddc05c4e1b2852$export$90990fedfc4ff8f4.info(`Build time: ${(0, $eyg9v.BUILD_TIME)} Build no: ${(0, $eyg9v.BUILD_NUMBER)} Version: ${(0, $eyg9v.VERSION_NUMBER)}`);
const $1eddc05c4e1b2852$export$1cff41e9a1c10268 = {
    buildTime: (0, $eyg9v.BUILD_TIME),
    versionNumber: (0, $eyg9v.VERSION_NUMBER)
};

// This is done via code because in index.html parcel omits a / prefix and the browser tries to load the
// font relative to the current path
(async ()=>{
    const font1Url = new URL((parcelRequire("dzPbc")));
    const binary = await fetch(font1Url);
    const resp = await binary.arrayBuffer();
    const font = new FontFace("Capture_it", resp, {
        style: "normal",
        weight: "normal"
    });
    document.fonts.add(font);
})();

const $1eddc05c4e1b2852$var$registerServiceWorker = async ()=>{
    if ("serviceWorker" in navigator) try {
        const registration = await navigator.serviceWorker.register((parcelRequire("kv3xU")));
        if (registration.installing) $1eddc05c4e1b2852$export$90990fedfc4ff8f4.info("Service worker installing");
        else if (registration.waiting) $1eddc05c4e1b2852$export$90990fedfc4ff8f4.info("Service worker installed");
        else if (registration.active) $1eddc05c4e1b2852$export$90990fedfc4ff8f4.info("Service worker is active");
    } catch (error) {
        $1eddc05c4e1b2852$export$90990fedfc4ff8f4.error(`Registration failed with ${error}`);
    }
};
// only use a service worker when not localhost and not native
if (window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1" && !(0, $k6Z8k.Capacitor).isNativePlatform()) {
    $1eddc05c4e1b2852$var$setupServiceWorkerWatchdog();
    $1eddc05c4e1b2852$var$registerServiceWorker().then(()=>{
        $1eddc05c4e1b2852$export$90990fedfc4ff8f4.info("Service worker handling finished");
    });
} else $1eddc05c4e1b2852$export$90990fedfc4ff8f4.info("Service worker handling skipped");

(parcelRequire("6FHsx")).then(()=>{
    $1eddc05c4e1b2852$export$90990fedfc4ff8f4.info("Frontend loaded");
    $1eddc05c4e1b2852$var$finishedThisModule = true;
});

});
parcelRegister("k6Z8k", function(module, exports) {

$parcel$export(module.exports, "Capacitor", () => $ea43c9f9cc282488$export$ab659bfd88afdf29);
$parcel$export(module.exports, "registerPlugin", () => $ea43c9f9cc282488$export$7612db19fb8beb1e);
$parcel$export(module.exports, "WebPlugin", () => $ea43c9f9cc282488$export$7c58ec35c4c5ea54);
$parcel$export(module.exports, "CapacitorHttp", () => $ea43c9f9cc282488$export$380134cb65b51303);
/*! Capacitor: https://capacitorjs.com/ - MIT License */ var $ea43c9f9cc282488$export$f8972ddbe8205c4b;
(function(ExceptionCode) {
    /**
     * API is not implemented.
     *
     * This usually means the API can't be used because it is not implemented for
     * the current platform.
     */ ExceptionCode["Unimplemented"] = "UNIMPLEMENTED";
    /**
     * API is not available.
     *
     * This means the API can't be used right now because:
     *   - it is currently missing a prerequisite, such as network connectivity
     *   - it requires a particular platform or browser version
     */ ExceptionCode["Unavailable"] = "UNAVAILABLE";
})($ea43c9f9cc282488$export$f8972ddbe8205c4b || ($ea43c9f9cc282488$export$f8972ddbe8205c4b = {}));
class $ea43c9f9cc282488$export$12e569be5e83b9f4 extends Error {
    constructor(message, code, data){
        super(message);
        this.message = message;
        this.code = code;
        this.data = data;
    }
}
const $ea43c9f9cc282488$var$getPlatformId = (win)=>{
    var _a, _b;
    if (win === null || win === void 0 ? void 0 : win.androidBridge) return "android";
    else if ((_b = (_a = win === null || win === void 0 ? void 0 : win.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.bridge) return "ios";
    else return "web";
};
const $ea43c9f9cc282488$var$createCapacitor = (win)=>{
    const capCustomPlatform = win.CapacitorCustomPlatform || null;
    const cap = win.Capacitor || {};
    const Plugins = cap.Plugins = cap.Plugins || {};
    const getPlatform = ()=>{
        return capCustomPlatform !== null ? capCustomPlatform.name : $ea43c9f9cc282488$var$getPlatformId(win);
    };
    const isNativePlatform = ()=>getPlatform() !== "web";
    const isPluginAvailable = (pluginName)=>{
        const plugin = registeredPlugins.get(pluginName);
        if (plugin === null || plugin === void 0 ? void 0 : plugin.platforms.has(getPlatform())) // JS implementation available for the current platform.
        return true;
        if (getPluginHeader(pluginName)) // Native implementation available.
        return true;
        return false;
    };
    const getPluginHeader = (pluginName)=>{
        var _a;
        return (_a = cap.PluginHeaders) === null || _a === void 0 ? void 0 : _a.find((h)=>h.name === pluginName);
    };
    const handleError = (err)=>win.console.error(err);
    const registeredPlugins = new Map();
    const registerPlugin = (pluginName, jsImplementations = {})=>{
        const registeredPlugin = registeredPlugins.get(pluginName);
        if (registeredPlugin) {
            console.warn(`Capacitor plugin "${pluginName}" already registered. Cannot register plugins twice.`);
            return registeredPlugin.proxy;
        }
        const platform = getPlatform();
        const pluginHeader = getPluginHeader(pluginName);
        let jsImplementation;
        const loadPluginImplementation = async ()=>{
            if (!jsImplementation && platform in jsImplementations) jsImplementation = typeof jsImplementations[platform] === "function" ? jsImplementation = await jsImplementations[platform]() : jsImplementation = jsImplementations[platform];
            else if (capCustomPlatform !== null && !jsImplementation && "web" in jsImplementations) jsImplementation = typeof jsImplementations["web"] === "function" ? jsImplementation = await jsImplementations["web"]() : jsImplementation = jsImplementations["web"];
            return jsImplementation;
        };
        const createPluginMethod = (impl, prop)=>{
            var _a, _b;
            if (pluginHeader) {
                const methodHeader = pluginHeader === null || pluginHeader === void 0 ? void 0 : pluginHeader.methods.find((m)=>prop === m.name);
                if (methodHeader) {
                    if (methodHeader.rtype === "promise") return (options)=>cap.nativePromise(pluginName, prop.toString(), options);
                    else return (options, callback)=>cap.nativeCallback(pluginName, prop.toString(), options, callback);
                } else if (impl) return (_a = impl[prop]) === null || _a === void 0 ? void 0 : _a.bind(impl);
            } else if (impl) return (_b = impl[prop]) === null || _b === void 0 ? void 0 : _b.bind(impl);
            else throw new $ea43c9f9cc282488$export$12e569be5e83b9f4(`"${pluginName}" plugin is not implemented on ${platform}`, $ea43c9f9cc282488$export$f8972ddbe8205c4b.Unimplemented);
        };
        const createPluginMethodWrapper = (prop)=>{
            let remove;
            const wrapper = (...args)=>{
                const p = loadPluginImplementation().then((impl)=>{
                    const fn = createPluginMethod(impl, prop);
                    if (fn) {
                        const p = fn(...args);
                        remove = p === null || p === void 0 ? void 0 : p.remove;
                        return p;
                    } else throw new $ea43c9f9cc282488$export$12e569be5e83b9f4(`"${pluginName}.${prop}()" is not implemented on ${platform}`, $ea43c9f9cc282488$export$f8972ddbe8205c4b.Unimplemented);
                });
                if (prop === "addListener") p.remove = async ()=>remove();
                return p;
            };
            // Some flair ✨
            wrapper.toString = ()=>`${prop.toString()}() { [capacitor code] }`;
            Object.defineProperty(wrapper, "name", {
                value: prop,
                writable: false,
                configurable: false
            });
            return wrapper;
        };
        const addListener = createPluginMethodWrapper("addListener");
        const removeListener = createPluginMethodWrapper("removeListener");
        const addListenerNative = (eventName, callback)=>{
            const call = addListener({
                eventName: eventName
            }, callback);
            const remove = async ()=>{
                const callbackId = await call;
                removeListener({
                    eventName: eventName,
                    callbackId: callbackId
                }, callback);
            };
            const p = new Promise((resolve)=>call.then(()=>resolve({
                        remove: remove
                    })));
            p.remove = async ()=>{
                console.warn(`Using addListener() without 'await' is deprecated.`);
                await remove();
            };
            return p;
        };
        const proxy = new Proxy({}, {
            get (_, prop) {
                switch(prop){
                    // https://github.com/facebook/react/issues/20030
                    case "$$typeof":
                        return undefined;
                    case "toJSON":
                        return ()=>({});
                    case "addListener":
                        return pluginHeader ? addListenerNative : addListener;
                    case "removeListener":
                        return removeListener;
                    default:
                        return createPluginMethodWrapper(prop);
                }
            }
        });
        Plugins[pluginName] = proxy;
        registeredPlugins.set(pluginName, {
            name: pluginName,
            proxy: proxy,
            platforms: new Set([
                ...Object.keys(jsImplementations),
                ...pluginHeader ? [
                    platform
                ] : []
            ])
        });
        return proxy;
    };
    // Add in convertFileSrc for web, it will already be available in native context
    if (!cap.convertFileSrc) cap.convertFileSrc = (filePath)=>filePath;
    cap.getPlatform = getPlatform;
    cap.handleError = handleError;
    cap.isNativePlatform = isNativePlatform;
    cap.isPluginAvailable = isPluginAvailable;
    cap.registerPlugin = registerPlugin;
    cap.Exception = $ea43c9f9cc282488$export$12e569be5e83b9f4;
    cap.DEBUG = !!cap.DEBUG;
    cap.isLoggingEnabled = !!cap.isLoggingEnabled;
    return cap;
};
const $ea43c9f9cc282488$var$initCapacitorGlobal = (win)=>win.Capacitor = $ea43c9f9cc282488$var$createCapacitor(win);
const $ea43c9f9cc282488$export$ab659bfd88afdf29 = /*#__PURE__*/ $ea43c9f9cc282488$var$initCapacitorGlobal(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
const $ea43c9f9cc282488$export$7612db19fb8beb1e = $ea43c9f9cc282488$export$ab659bfd88afdf29.registerPlugin;
/**
 * Base class web plugins should extend.
 */ class $ea43c9f9cc282488$export$7c58ec35c4c5ea54 {
    constructor(){
        this.listeners = {};
        this.retainedEventArguments = {};
        this.windowListeners = {};
    }
    addListener(eventName, listenerFunc) {
        let firstListener = false;
        const listeners = this.listeners[eventName];
        if (!listeners) {
            this.listeners[eventName] = [];
            firstListener = true;
        }
        this.listeners[eventName].push(listenerFunc);
        // If we haven't added a window listener for this event and it requires one,
        // go ahead and add it
        const windowListener = this.windowListeners[eventName];
        if (windowListener && !windowListener.registered) this.addWindowListener(windowListener);
        if (firstListener) this.sendRetainedArgumentsForEvent(eventName);
        const remove = async ()=>this.removeListener(eventName, listenerFunc);
        const p = Promise.resolve({
            remove: remove
        });
        return p;
    }
    async removeAllListeners() {
        this.listeners = {};
        for(const listener in this.windowListeners)this.removeWindowListener(this.windowListeners[listener]);
        this.windowListeners = {};
    }
    notifyListeners(eventName, data, retainUntilConsumed) {
        const listeners = this.listeners[eventName];
        if (!listeners) {
            if (retainUntilConsumed) {
                let args = this.retainedEventArguments[eventName];
                if (!args) args = [];
                args.push(data);
                this.retainedEventArguments[eventName] = args;
            }
            return;
        }
        listeners.forEach((listener)=>listener(data));
    }
    hasListeners(eventName) {
        var _a;
        return !!((_a = this.listeners[eventName]) === null || _a === void 0 ? void 0 : _a.length);
    }
    registerWindowListener(windowEventName, pluginEventName) {
        this.windowListeners[pluginEventName] = {
            registered: false,
            windowEventName: windowEventName,
            pluginEventName: pluginEventName,
            handler: (event)=>{
                this.notifyListeners(pluginEventName, event);
            }
        };
    }
    unimplemented(msg = "not implemented") {
        return new $ea43c9f9cc282488$export$ab659bfd88afdf29.Exception(msg, $ea43c9f9cc282488$export$f8972ddbe8205c4b.Unimplemented);
    }
    unavailable(msg = "not available") {
        return new $ea43c9f9cc282488$export$ab659bfd88afdf29.Exception(msg, $ea43c9f9cc282488$export$f8972ddbe8205c4b.Unavailable);
    }
    async removeListener(eventName, listenerFunc) {
        const listeners = this.listeners[eventName];
        if (!listeners) return;
        const index = listeners.indexOf(listenerFunc);
        this.listeners[eventName].splice(index, 1);
        // If there are no more listeners for this type of event,
        // remove the window listener
        if (!this.listeners[eventName].length) this.removeWindowListener(this.windowListeners[eventName]);
    }
    addWindowListener(handle) {
        window.addEventListener(handle.windowEventName, handle.handler);
        handle.registered = true;
    }
    removeWindowListener(handle) {
        if (!handle) return;
        window.removeEventListener(handle.windowEventName, handle.handler);
        handle.registered = false;
    }
    sendRetainedArgumentsForEvent(eventName) {
        const args = this.retainedEventArguments[eventName];
        if (!args) return;
        delete this.retainedEventArguments[eventName];
        args.forEach((arg)=>{
            this.notifyListeners(eventName, arg);
        });
    }
}
const $ea43c9f9cc282488$export$9ac0cb180b81cd43 = /*#__PURE__*/ $ea43c9f9cc282488$export$7612db19fb8beb1e("WebView");
/******** END WEB VIEW PLUGIN ********/ /******** COOKIES PLUGIN ********/ /**
 * Safely web encode a string value (inspired by js-cookie)
 * @param str The string value to encode
 */ const $ea43c9f9cc282488$var$encode = (str)=>encodeURIComponent(str).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
/**
 * Safely web decode a string value (inspired by js-cookie)
 * @param str The string value to decode
 */ const $ea43c9f9cc282488$var$decode = (str)=>str.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
class $ea43c9f9cc282488$var$CapacitorCookiesPluginWeb extends $ea43c9f9cc282488$export$7c58ec35c4c5ea54 {
    async getCookies() {
        const cookies = document.cookie;
        const cookieMap = {};
        cookies.split(";").forEach((cookie)=>{
            if (cookie.length <= 0) return;
            // Replace first "=" with CAP_COOKIE to prevent splitting on additional "="
            let [key, value] = cookie.replace(/=/, "CAP_COOKIE").split("CAP_COOKIE");
            key = $ea43c9f9cc282488$var$decode(key).trim();
            value = $ea43c9f9cc282488$var$decode(value).trim();
            cookieMap[key] = value;
        });
        return cookieMap;
    }
    async setCookie(options) {
        try {
            // Safely Encoded Key/Value
            const encodedKey = $ea43c9f9cc282488$var$encode(options.key);
            const encodedValue = $ea43c9f9cc282488$var$encode(options.value);
            // Clean & sanitize options
            const expires = options.expires ? `; expires=${options.expires.replace("expires=", "")}` : "";
            const path = (options.path || "/").replace("path=", ""); // Default is "path=/"
            const domain = options.url != null && options.url.length > 0 ? `domain=${options.url}` : "";
            document.cookie = `${encodedKey}=${encodedValue || ""}${expires}; path=${path}; ${domain};`;
        } catch (error) {
            return Promise.reject(error);
        }
    }
    async deleteCookie(options) {
        try {
            document.cookie = `${options.key}=; Max-Age=0`;
        } catch (error) {
            return Promise.reject(error);
        }
    }
    async clearCookies() {
        try {
            const cookies = document.cookie.split(";") || [];
            for (const cookie of cookies)document.cookie = cookie.replace(/^ +/, "").replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
        } catch (error) {
            return Promise.reject(error);
        }
    }
    async clearAllCookies() {
        try {
            await this.clearCookies();
        } catch (error) {
            return Promise.reject(error);
        }
    }
}
const $ea43c9f9cc282488$export$702e5c97f7e4f579 = $ea43c9f9cc282488$export$7612db19fb8beb1e("CapacitorCookies", {
    web: ()=>new $ea43c9f9cc282488$var$CapacitorCookiesPluginWeb()
});
// UTILITY FUNCTIONS
/**
 * Read in a Blob value and return it as a base64 string
 * @param blob The blob value to convert to a base64 string
 */ const $ea43c9f9cc282488$var$readBlobAsBase64 = async (blob)=>new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            const base64String = reader.result;
            // remove prefix "data:application/pdf;base64,"
            resolve(base64String.indexOf(",") >= 0 ? base64String.split(",")[1] : base64String);
        };
        reader.onerror = (error)=>reject(error);
        reader.readAsDataURL(blob);
    });
/**
 * Normalize an HttpHeaders map by lowercasing all of the values
 * @param headers The HttpHeaders object to normalize
 */ const $ea43c9f9cc282488$var$normalizeHttpHeaders = (headers = {})=>{
    const originalKeys = Object.keys(headers);
    const loweredKeys = Object.keys(headers).map((k)=>k.toLocaleLowerCase());
    const normalized = loweredKeys.reduce((acc, key, index)=>{
        acc[key] = headers[originalKeys[index]];
        return acc;
    }, {});
    return normalized;
};
/**
 * Builds a string of url parameters that
 * @param params A map of url parameters
 * @param shouldEncode true if you should encodeURIComponent() the values (true by default)
 */ const $ea43c9f9cc282488$var$buildUrlParams = (params, shouldEncode = true)=>{
    if (!params) return null;
    const output = Object.entries(params).reduce((accumulator, entry)=>{
        const [key, value] = entry;
        let encodedValue;
        let item;
        if (Array.isArray(value)) {
            item = "";
            value.forEach((str)=>{
                encodedValue = shouldEncode ? encodeURIComponent(str) : str;
                item += `${key}=${encodedValue}&`;
            });
            // last character will always be "&" so slice it off
            item.slice(0, -1);
        } else {
            encodedValue = shouldEncode ? encodeURIComponent(value) : value;
            item = `${key}=${encodedValue}`;
        }
        return `${accumulator}&${item}`;
    }, "");
    // Remove initial "&" from the reduce
    return output.substr(1);
};
/**
 * Build the RequestInit object based on the options passed into the initial request
 * @param options The Http plugin options
 * @param extra Any extra RequestInit values
 */ const $ea43c9f9cc282488$export$bd53726ce92e1297 = (options, extra = {})=>{
    const output = Object.assign({
        method: options.method || "GET",
        headers: options.headers
    }, extra);
    // Get the content-type
    const headers = $ea43c9f9cc282488$var$normalizeHttpHeaders(options.headers);
    const type = headers["content-type"] || "";
    // If body is already a string, then pass it through as-is.
    if (typeof options.data === "string") output.body = options.data;
    else if (type.includes("application/x-www-form-urlencoded")) {
        const params = new URLSearchParams();
        for (const [key, value] of Object.entries(options.data || {}))params.set(key, value);
        output.body = params.toString();
    } else if (type.includes("multipart/form-data") || options.data instanceof FormData) {
        const form = new FormData();
        if (options.data instanceof FormData) options.data.forEach((value, key)=>{
            form.append(key, value);
        });
        else for (const key of Object.keys(options.data))form.append(key, options.data[key]);
        output.body = form;
        const headers = new Headers(output.headers);
        headers.delete("content-type"); // content-type will be set by `window.fetch` to includy boundary
        output.headers = headers;
    } else if (type.includes("application/json") || typeof options.data === "object") output.body = JSON.stringify(options.data);
    return output;
};
// WEB IMPLEMENTATION
class $ea43c9f9cc282488$var$CapacitorHttpPluginWeb extends $ea43c9f9cc282488$export$7c58ec35c4c5ea54 {
    /**
     * Perform an Http request given a set of options
     * @param options Options to build the HTTP request
     */ async request(options) {
        const requestInit = $ea43c9f9cc282488$export$bd53726ce92e1297(options, options.webFetchExtra);
        const urlParams = $ea43c9f9cc282488$var$buildUrlParams(options.params, options.shouldEncodeUrlParams);
        const url = urlParams ? `${options.url}?${urlParams}` : options.url;
        const response = await fetch(url, requestInit);
        const contentType = response.headers.get("content-type") || "";
        // Default to 'text' responseType so no parsing happens
        let { responseType: responseType = "text" } = response.ok ? options : {};
        // If the response content-type is json, force the response to be json
        if (contentType.includes("application/json")) responseType = "json";
        let data;
        let blob;
        switch(responseType){
            case "arraybuffer":
            case "blob":
                blob = await response.blob();
                data = await $ea43c9f9cc282488$var$readBlobAsBase64(blob);
                break;
            case "json":
                data = await response.json();
                break;
            case "document":
            case "text":
            default:
                data = await response.text();
        }
        // Convert fetch headers to Capacitor HttpHeaders
        const headers = {};
        response.headers.forEach((value, key)=>{
            headers[key] = value;
        });
        return {
            data: data,
            headers: headers,
            status: response.status,
            url: response.url
        };
    }
    /**
     * Perform an Http GET request given a set of options
     * @param options Options to build the HTTP request
     */ async get(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: "GET"
        }));
    }
    /**
     * Perform an Http POST request given a set of options
     * @param options Options to build the HTTP request
     */ async post(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: "POST"
        }));
    }
    /**
     * Perform an Http PUT request given a set of options
     * @param options Options to build the HTTP request
     */ async put(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: "PUT"
        }));
    }
    /**
     * Perform an Http PATCH request given a set of options
     * @param options Options to build the HTTP request
     */ async patch(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: "PATCH"
        }));
    }
    /**
     * Perform an Http DELETE request given a set of options
     * @param options Options to build the HTTP request
     */ async delete(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: "DELETE"
        }));
    }
}
const $ea43c9f9cc282488$export$380134cb65b51303 = $ea43c9f9cc282488$export$7612db19fb8beb1e("CapacitorHttp", {
    web: ()=>new $ea43c9f9cc282488$var$CapacitorHttpPluginWeb()
});

});

parcelRegister("5IvUh", function(module, exports) {

$parcel$export(module.exports, "ScreenOrientation", () => $4299cfd55e5f96eb$export$2bc34ef97fee356d);

var $k6Z8k = parcelRequire("k6Z8k");
parcelRequire("jFdvI");

const $4299cfd55e5f96eb$export$2bc34ef97fee356d = (0, $k6Z8k.registerPlugin)("ScreenOrientation", {
    web: ()=>(parcelRequire("6YfVk")).then((m)=>new m.ScreenOrientationWeb())
});

});
parcelRegister("jFdvI", function(module, exports) {

});

parcelRegister("6YfVk", function(module, exports) {

var $Apt1V = parcelRequire("Apt1V");
module.exports = $Apt1V("2DXiy").then(()=>parcelRequire("2fWsu"));

});
parcelRegister("Apt1V", function(module, exports) {
"use strict";

function $06d71e2b19616c4e$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("lmaeY")).resolve(id));
}
module.exports = $06d71e2b19616c4e$var$load;

});



parcelRegister("jRama", function(module, exports) {

$parcel$export(module.exports, "LoggerUtil", () => $e488a18997f5d1af$export$1605cc4fc0ce8504);
$parcel$export(module.exports, "LoggerImpl", () => $e488a18997f5d1af$export$f6a47e99604de960);
// disable eslint for this file
/* eslint-disable @typescript-eslint/no-explicit-any */ var $e488a18997f5d1af$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "debug";
    LogLevel["INFO"] = "info";
    LogLevel["WARN"] = "warn";
    LogLevel["ERROR"] = "error";
})($e488a18997f5d1af$export$243e62d78d3b544d || ($e488a18997f5d1af$export$243e62d78d3b544d = {}));
class $e488a18997f5d1af$export$1605cc4fc0ce8504 {
    static to24HourTime(date) {
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const seconds = date.getSeconds().toString().padStart(2, "0");
        return `${hours}:${minutes}:${seconds}`;
    }
    // https://stackoverflow.com/questions/9382167/serializing-object-that-contains-cyclic-object-value
    static decycle(obj, stack = []) {
        if (!obj || typeof obj !== "object") return obj;
        if (stack.includes(obj)) return null;
        const s = stack.concat([
            obj
        ]);
        return Array.isArray(obj) ? obj.map((x)=>$e488a18997f5d1af$export$1605cc4fc0ce8504.decycle(x, s)) : Object.fromEntries(Object.entries(obj).map(([k, v])=>[
                k,
                $e488a18997f5d1af$export$1605cc4fc0ce8504.decycle(v, s)
            ]));
    }
    static formatSmall(entry) {
        const fst = `${$e488a18997f5d1af$export$1605cc4fc0ce8504.to24HourTime(entry.timestamp)} [${entry.level[0]}] ${entry.message}`;
        if (entry.params && entry.params.length > 0) return `${fst} ${entry.params.map((param)=>JSON.stringify($e488a18997f5d1af$export$1605cc4fc0ce8504.decycle(param))).join(" ")}`;
        else return fst;
    }
}
class $e488a18997f5d1af$export$f6a47e99604de960 {
    constructor(sinks = []){
        this.sinks = [];
        this.sinks = sinks;
    }
    registerSink(sink) {
        this.sinks.push(sink);
    }
    log(level, message, ...params) {
        const timestamp = new Date();
        const entry = {
            level: level,
            message: message,
            timestamp: timestamp,
            params: params
        };
        this.sinks.forEach((sink)=>sink.log(entry));
    }
    debug(message, ...params) {
        this.log("debug", message, ...params);
    }
    info(message, ...params) {
        this.log("info", message, ...params);
    }
    warn(message, ...params) {
        this.log("warn", message, ...params);
    }
    error(message, ...params) {
        const msg = message instanceof Error ? message.stack ?? "stack not available" : message;
        this.log("error", msg, ...params);
        if (params) // eslint-disable-next-line no-console
        params.forEach((param)=>console.error(param));
    }
}

});

parcelRegister("4e7wm", function(module, exports) {

$parcel$export(module.exports, "BrowserConsoleLogger", () => $e657b2561cbe13cc$export$693c51b11073fee);

var $jRama = parcelRequire("jRama");
class $e657b2561cbe13cc$export$693c51b11073fee {
    log(entry) {
        console.log((0, $jRama.LoggerUtil).formatSmall(entry));
    }
}

});

parcelRegister("2Xgi8", function(module, exports) {

$parcel$export(module.exports, "HtmlConsoleLogger", () => $9dd41cf95032d067$export$3db156a282beade9);

var $jRama = parcelRequire("jRama");
class $9dd41cf95032d067$export$3db156a282beade9 {
    constructor(id, maxHeight){
        this.id = id;
        this.maxHeight = maxHeight;
        this.consoleElement = document.getElementById(id);
        if (!this.consoleElement) throw new Error(`Element with id "${id}" not found`);
        this.consoleElement.style.height = `${maxHeight}px`;
        this.consoleElement.style.maxHeight = `${maxHeight}px`;
        this.consoleElement.style.width = "100%";
        this.consoleElement.style.overflowY = "auto";
        this.consoleElement.style.border = "1px solid black";
        this.consoleElement.style.padding = "0px";
        this.consoleElement.style.margin = "0px";
        this.consoleElement.style.top = "0px";
        this.consoleElement.style.fontFamily = "monospace";
        this.consoleElement.style.whiteSpace = "pre-wrap";
        this.consoleElement.style.backgroundColor = "#f0f0f040";
        this.consoleElement.style.position = "absolute";
        this.consoleElement.setAttribute("class", "fs-xs");
        this.lineContainer = document.createElement("div");
        this.consoleElement.appendChild(this.lineContainer);
    }
    addLine(line) {
        const lineElement = document.createElement("div");
        lineElement.style.lineBreak = "anywhere";
        lineElement.textContent = line;
        this.lineContainer.appendChild(lineElement);
        // Scroll to the bottom
        this.consoleElement.scrollTop = this.consoleElement.scrollHeight;
    }
    log(entry) {
        this.addLine((0, $jRama.LoggerUtil).formatSmall(entry));
    // if (entry.error) {
    //     const err = entry.error as unknown as Error;
    //     this.addLine(err.message);
    // }
    }
}

});

parcelRegister("eyg9v", function(module, exports) {

$parcel$export(module.exports, "BUILD_TIME", () => $a980c52a7175cace$export$a716cf793ad7f839);
$parcel$export(module.exports, "BUILD_NUMBER", () => $a980c52a7175cace$export$59b5344f0ddeca73);
$parcel$export(module.exports, "VERSION_NUMBER", () => $a980c52a7175cace$export$862627d4c720c7b9);
$parcel$export(module.exports, "_register", () => $a980c52a7175cace$export$c208e1278d7beb2);
let $a980c52a7175cace$export$a716cf793ad7f839 = "n/a";
let $a980c52a7175cace$export$59b5344f0ddeca73 = "n/a";
let $a980c52a7175cace$export$862627d4c720c7b9 = "n/a";
function $a980c52a7175cace$export$c208e1278d7beb2(b, bn, v) {
    $a980c52a7175cace$export$a716cf793ad7f839 = b;
    $a980c52a7175cace$export$59b5344f0ddeca73 = bn;
    $a980c52a7175cace$export$862627d4c720c7b9 = v;
}

});

parcelRegister("k4cEx", function(module, exports) {

$parcel$export(module.exports, "StatusBar", () => $e9bdfefa6e14f2f0$export$3ae18a2a755cc9c8);

var $k6Z8k = parcelRequire("k6Z8k");
parcelRequire("p1wXm");
const $e9bdfefa6e14f2f0$export$3ae18a2a755cc9c8 = (0, $k6Z8k.registerPlugin)("StatusBar");

});
parcelRegister("p1wXm", function(module, exports) {
/// <reference types="@capacitor/cli" />
var $04b385d9b09ace0d$export$d9e45bc13d335801;
(function(Style) {
    /**
     * Light text for dark backgrounds.
     *
     * @since 1.0.0
     */ Style["Dark"] = "DARK";
    /**
     * Dark text for light backgrounds.
     *
     * @since 1.0.0
     */ Style["Light"] = "LIGHT";
    /**
     * The style is based on the device appearance.
     * If the device is using Dark mode, the statusbar text will be light.
     * If the device is using Light mode, the statusbar text will be dark.
     *
     * @since 1.0.0
     */ Style["Default"] = "DEFAULT";
})($04b385d9b09ace0d$export$d9e45bc13d335801 || ($04b385d9b09ace0d$export$d9e45bc13d335801 = {}));
var $04b385d9b09ace0d$export$c35d437ae5945fcd;
(function(Animation) {
    /**
     * No animation during show/hide.
     *
     * @since 1.0.0
     */ Animation["None"] = "NONE";
    /**
     * Slide animation during show/hide.
     * It doesn't work on iOS 15+.
     *
     * @deprecated Use Animation.Fade or Animation.None instead.
     *
     * @since 1.0.0
     */ Animation["Slide"] = "SLIDE";
    /**
     * Fade animation during show/hide.
     *
     * @since 1.0.0
     */ Animation["Fade"] = "FADE";
})($04b385d9b09ace0d$export$c35d437ae5945fcd || ($04b385d9b09ace0d$export$c35d437ae5945fcd = {}));
const $04b385d9b09ace0d$export$1c3ac045e2c28a72 = $04b385d9b09ace0d$export$c35d437ae5945fcd;
const $04b385d9b09ace0d$export$7d9c595f759c9481 = $04b385d9b09ace0d$export$d9e45bc13d335801;

});


parcelRegister("7XkqE", function(module, exports) {

var $4CmsM = parcelRequire("4CmsM");
parcelRequire("8wPBw");
var $5cade3d0a6ec03a4$var$o = {};
function $5cade3d0a6ec03a4$export$57a0cba2fdd874ef() {
    $5cade3d0a6ec03a4$var$o = {};
}
function $5cade3d0a6ec03a4$var$a(e) {
    return e.type === (0, $4CmsM.Fragment) ? "Fragment" : "function" == typeof e.type ? e.type.displayName || e.type.name : "string" == typeof e.type ? e.type : "#text";
}
var $5cade3d0a6ec03a4$var$i = [], $5cade3d0a6ec03a4$var$s = [];
function $5cade3d0a6ec03a4$var$c() {
    return $5cade3d0a6ec03a4$var$i.length > 0 ? $5cade3d0a6ec03a4$var$i[$5cade3d0a6ec03a4$var$i.length - 1] : null;
}
var $5cade3d0a6ec03a4$var$l = !0;
function $5cade3d0a6ec03a4$var$u(e) {
    return "function" == typeof e.type && e.type != (0, $4CmsM.Fragment);
}
function $5cade3d0a6ec03a4$var$f(n) {
    for(var e = [
        n
    ], t = n; null != t.__o;)e.push(t.__o), t = t.__o;
    return e.reduce(function(n, e) {
        n += "  in " + $5cade3d0a6ec03a4$var$a(e);
        var t = e.__source;
        return t ? n += " (at " + t.fileName + ":" + t.lineNumber + ")" : $5cade3d0a6ec03a4$var$l && console.warn("Add @babel/plugin-transform-react-jsx-source to get a more detailed component stack. Note that you should not add it to production builds of your App for bundle size reasons."), $5cade3d0a6ec03a4$var$l = !1, n + "\n";
    }, "");
}
var $5cade3d0a6ec03a4$var$p = "function" == typeof WeakMap;
function $5cade3d0a6ec03a4$var$d(n) {
    var e = [];
    return n.__k ? (n.__k.forEach(function(n) {
        n && "function" == typeof n.type ? e.push.apply(e, $5cade3d0a6ec03a4$var$d(n)) : n && "string" == typeof n.type && e.push(n.type);
    }), e) : e;
}
function $5cade3d0a6ec03a4$var$h(n) {
    return n ? "function" == typeof n.type ? null == n.__ ? null != n.__e && null != n.__e.parentNode ? n.__e.parentNode.localName : "" : $5cade3d0a6ec03a4$var$h(n.__) : n.type : "";
}
var $5cade3d0a6ec03a4$var$v = (0, $4CmsM.Component).prototype.setState;
function $5cade3d0a6ec03a4$var$y(n) {
    return "table" === n || "tfoot" === n || "tbody" === n || "thead" === n || "td" === n || "tr" === n || "th" === n;
}
(0, $4CmsM.Component).prototype.setState = function(n, e) {
    return null == this.__v && null == this.state && console.warn('Calling "this.setState" inside the constructor of a component is a no-op and might be a bug in your application. Instead, set "this.state = {}" directly.\n\n' + $5cade3d0a6ec03a4$var$f($5cade3d0a6ec03a4$var$c())), $5cade3d0a6ec03a4$var$v.call(this, n, e);
};
var $5cade3d0a6ec03a4$var$m = /^(address|article|aside|blockquote|details|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|main|menu|nav|ol|p|pre|search|section|table|ul)$/, $5cade3d0a6ec03a4$var$b = (0, $4CmsM.Component).prototype.forceUpdate;
function $5cade3d0a6ec03a4$var$w(n) {
    var e = n.props, t = $5cade3d0a6ec03a4$var$a(n), o = "";
    for(var r in e)if (e.hasOwnProperty(r) && "children" !== r) {
        var i = e[r];
        "function" == typeof i && (i = "function " + (i.displayName || i.name) + "() {}"), i = Object(i) !== i || i.toString ? i + "" : Object.prototype.toString.call(i), o += " " + r + "=" + JSON.stringify(i);
    }
    var s = e.children;
    return "<" + t + o + (s && s.length ? ">..</" + t + ">" : " />");
}
(0, $4CmsM.Component).prototype.forceUpdate = function(n) {
    return null == this.__v ? console.warn('Calling "this.forceUpdate" inside the constructor of a component is a no-op and might be a bug in your application.\n\n' + $5cade3d0a6ec03a4$var$f($5cade3d0a6ec03a4$var$c())) : null == this.__P && console.warn('Can\'t call "this.forceUpdate" on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in the componentWillUnmount method.\n\n' + $5cade3d0a6ec03a4$var$f(this.__v)), $5cade3d0a6ec03a4$var$b.call(this, n);
}, function() {
    !function() {
        var n = (0, $4CmsM.options).__b, t = (0, $4CmsM.options).diffed, o = (0, $4CmsM.options).__, r = (0, $4CmsM.options).vnode, a = (0, $4CmsM.options).__r;
        (0, $4CmsM.options).diffed = function(n) {
            $5cade3d0a6ec03a4$var$u(n) && $5cade3d0a6ec03a4$var$s.pop(), $5cade3d0a6ec03a4$var$i.pop(), t && t(n);
        }, (0, $4CmsM.options).__b = function(e) {
            $5cade3d0a6ec03a4$var$u(e) && $5cade3d0a6ec03a4$var$i.push(e), n && n(e);
        }, (0, $4CmsM.options).__ = function(n, e) {
            $5cade3d0a6ec03a4$var$s = [], o && o(n, e);
        }, (0, $4CmsM.options).vnode = function(n) {
            n.__o = $5cade3d0a6ec03a4$var$s.length > 0 ? $5cade3d0a6ec03a4$var$s[$5cade3d0a6ec03a4$var$s.length - 1] : null, r && r(n);
        }, (0, $4CmsM.options).__r = function(n) {
            $5cade3d0a6ec03a4$var$u(n) && $5cade3d0a6ec03a4$var$s.push(n), a && a(n);
        };
    }();
    var n = !1, t = (0, $4CmsM.options).__b, r = (0, $4CmsM.options).diffed, c = (0, $4CmsM.options).vnode, l = (0, $4CmsM.options).__r, v = (0, $4CmsM.options).__e, b = (0, $4CmsM.options).__, g = (0, $4CmsM.options).__h, E = $5cade3d0a6ec03a4$var$p ? {
        useEffect: new WeakMap,
        useLayoutEffect: new WeakMap,
        lazyPropTypes: new WeakMap
    } : null, k = [];
    (0, $4CmsM.options).__e = function(n, e, t, o) {
        if (e && e.__c && "function" == typeof n.then) {
            var r = n;
            n = new Error("Missing Suspense. The throwing component was: " + $5cade3d0a6ec03a4$var$a(e));
            for(var i = e; i; i = i.__)if (i.__c && i.__c.__c) {
                n = r;
                break;
            }
            if (n instanceof Error) throw n;
        }
        try {
            (o = o || {}).componentStack = $5cade3d0a6ec03a4$var$f(e), v(n, e, t, o), "function" != typeof n.then && setTimeout(function() {
                throw n;
            });
        } catch (n) {
            throw n;
        }
    }, (0, $4CmsM.options).__ = function(n, e) {
        if (!e) throw new Error("Undefined parent passed to render(), this is the second argument.\nCheck if the element is available in the DOM/has the correct id.");
        var t;
        switch(e.nodeType){
            case 1:
            case 11:
            case 9:
                t = !0;
                break;
            default:
                t = !1;
        }
        if (!t) {
            var o = $5cade3d0a6ec03a4$var$a(n);
            throw new Error("Expected a valid HTML node as a second argument to render.	Received " + e + " instead: render(<" + o + " />, " + e + ");");
        }
        b && b(n, e);
    }, (0, $4CmsM.options).__b = function(e) {
        var r = e.type;
        if (n = !0, void 0 === r) throw new Error("Undefined component passed to createElement()\n\nYou likely forgot to export your component or might have mixed up default and named imports" + $5cade3d0a6ec03a4$var$w(e) + "\n\n" + $5cade3d0a6ec03a4$var$f(e));
        if (null != r && "object" == typeof r) {
            if (void 0 !== r.__k && void 0 !== r.__e) throw new Error("Invalid type passed to createElement(): " + r + "\n\nDid you accidentally pass a JSX literal as JSX twice?\n\n  let My" + $5cade3d0a6ec03a4$var$a(e) + " = " + $5cade3d0a6ec03a4$var$w(r) + ";\n  let vnode = <My" + $5cade3d0a6ec03a4$var$a(e) + " />;\n\nThis usually happens when you export a JSX literal and not the component.\n\n" + $5cade3d0a6ec03a4$var$f(e));
            throw new Error("Invalid type passed to createElement(): " + (Array.isArray(r) ? "array" : r));
        }
        if (void 0 !== e.ref && "function" != typeof e.ref && "object" != typeof e.ref && !("$$typeof" in e)) throw new Error('Component\'s "ref" property should be a function, or an object created by createRef(), but got [' + typeof e.ref + "] instead\n" + $5cade3d0a6ec03a4$var$w(e) + "\n\n" + $5cade3d0a6ec03a4$var$f(e));
        if ("string" == typeof e.type) {
            for(var i in e.props)if ("o" === i[0] && "n" === i[1] && "function" != typeof e.props[i] && null != e.props[i]) throw new Error("Component's \"" + i + '" property should be a function, but got [' + typeof e.props[i] + "] instead\n" + $5cade3d0a6ec03a4$var$w(e) + "\n\n" + $5cade3d0a6ec03a4$var$f(e));
        }
        if ("function" == typeof e.type && e.type.propTypes) {
            if ("Lazy" === e.type.displayName && E && !E.lazyPropTypes.has(e.type)) {
                var s = "PropTypes are not supported on lazy(). Use propTypes on the wrapped component itself. ";
                try {
                    var c = e.type();
                    E.lazyPropTypes.set(e.type, !0), console.warn(s + "Component wrapped in lazy() is " + $5cade3d0a6ec03a4$var$a(c));
                } catch (n) {
                    console.warn(s + "We will log the wrapped component's name once it is loaded.");
                }
            }
            var l = e.props;
            e.type.__f && delete (l = function(n, e) {
                for(var t in e)n[t] = e[t];
                return n;
            }({}, l)).ref, function(n, e, t, r, a) {
                Object.keys(n).forEach(function(t) {
                    var i;
                    try {
                        i = n[t](e, t, r, "prop", null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
                    } catch (n) {
                        i = n;
                    }
                    i && !(i.message in $5cade3d0a6ec03a4$var$o) && ($5cade3d0a6ec03a4$var$o[i.message] = !0, console.error("Failed prop type: " + i.message + (a && "\n" + a() || "")));
                });
            }(e.type.propTypes, l, 0, $5cade3d0a6ec03a4$var$a(e), function() {
                return $5cade3d0a6ec03a4$var$f(e);
            });
        }
        t && t(e);
    };
    var _, T = 0;
    (0, $4CmsM.options).__r = function(e) {
        l && l(e), n = !0;
        var t = e.__c;
        if (t === _ ? T++ : T = 1, T >= 25) throw new Error("Too many re-renders. This is limited to prevent an infinite loop which may lock up your browser. The component causing this is: " + $5cade3d0a6ec03a4$var$a(e));
        _ = t;
    }, (0, $4CmsM.options).__h = function(e, t, o) {
        if (!e || !n) throw new Error("Hook can only be invoked from render methods.");
        g && g(e, t, o);
    };
    var I = function(n, e) {
        return {
            get: function() {
                var t = "get" + n + e;
                k && k.indexOf(t) < 0 && (k.push(t), console.warn("getting vnode." + n + " is deprecated, " + e));
            },
            set: function() {
                var t = "set" + n + e;
                k && k.indexOf(t) < 0 && (k.push(t), console.warn("setting vnode." + n + " is not allowed, " + e));
            }
        };
    }, j = {
        nodeName: I("nodeName", "use vnode.type"),
        attributes: I("attributes", "use vnode.props"),
        children: I("children", "use vnode.props.children")
    }, O = Object.create({}, j);
    (0, $4CmsM.options).vnode = function(n) {
        var e = n.props;
        if (null !== n.type && null != e && ("__source" in e || "__self" in e)) {
            var t = n.props = {};
            for(var o in e){
                var r = e[o];
                "__source" === o ? n.__source = r : "__self" === o ? n.__self = r : t[o] = r;
            }
        }
        n.__proto__ = O, c && c(n);
    }, (0, $4CmsM.options).diffed = function(e) {
        var t, o = e.type, i = e.__;
        if (e.__k && e.__k.forEach(function(n) {
            if ("object" == typeof n && n && void 0 === n.type) {
                var t = Object.keys(n).join(",");
                throw new Error("Objects are not valid as a child. Encountered an object with the keys {" + t + "}.\n\n" + $5cade3d0a6ec03a4$var$f(e));
            }
        }), e.__c === _ && (T = 0), "string" == typeof o && ($5cade3d0a6ec03a4$var$y(o) || "p" === o || "a" === o || "button" === o)) {
            var s = $5cade3d0a6ec03a4$var$h(i);
            if ("" !== s && $5cade3d0a6ec03a4$var$y(o)) "table" === o && "td" !== s && $5cade3d0a6ec03a4$var$y(s) ? (console.log(s, i.__e), console.error("Improper nesting of table. Your <table> should not have a table-node parent." + $5cade3d0a6ec03a4$var$w(e) + "\n\n" + $5cade3d0a6ec03a4$var$f(e))) : "thead" !== o && "tfoot" !== o && "tbody" !== o || "table" === s ? "tr" === o && "thead" !== s && "tfoot" !== s && "tbody" !== s ? console.error("Improper nesting of table. Your <tr> should have a <thead/tbody/tfoot> parent." + $5cade3d0a6ec03a4$var$w(e) + "\n\n" + $5cade3d0a6ec03a4$var$f(e)) : "td" === o && "tr" !== s ? console.error("Improper nesting of table. Your <td> should have a <tr> parent." + $5cade3d0a6ec03a4$var$w(e) + "\n\n" + $5cade3d0a6ec03a4$var$f(e)) : "th" === o && "tr" !== s && console.error("Improper nesting of table. Your <th> should have a <tr>." + $5cade3d0a6ec03a4$var$w(e) + "\n\n" + $5cade3d0a6ec03a4$var$f(e)) : console.error("Improper nesting of table. Your <thead/tbody/tfoot> should have a <table> parent." + $5cade3d0a6ec03a4$var$w(e) + "\n\n" + $5cade3d0a6ec03a4$var$f(e));
            else if ("p" === o) {
                var c = $5cade3d0a6ec03a4$var$d(e).filter(function(n) {
                    return $5cade3d0a6ec03a4$var$m.test(n);
                });
                c.length && console.error("Improper nesting of paragraph. Your <p> should not have " + c.join(", ") + "as child-elements." + $5cade3d0a6ec03a4$var$w(e) + "\n\n" + $5cade3d0a6ec03a4$var$f(e));
            } else "a" !== o && "button" !== o || -1 !== $5cade3d0a6ec03a4$var$d(e).indexOf(o) && console.error("Improper nesting of interactive content. Your <" + o + "> should not have other " + ("a" === o ? "anchor" : "button") + " tags as child-elements." + $5cade3d0a6ec03a4$var$w(e) + "\n\n" + $5cade3d0a6ec03a4$var$f(e));
        }
        if (n = !1, r && r(e), null != e.__k) for(var l = [], u = 0; u < e.__k.length; u++){
            var p = e.__k[u];
            if (p && null != p.key) {
                var v = p.key;
                if (-1 !== l.indexOf(v)) {
                    console.error('Following component has two or more children with the same key attribute: "' + v + '". This may cause glitches and misbehavior in rendering process. Component: \n\n' + $5cade3d0a6ec03a4$var$w(e) + "\n\n" + $5cade3d0a6ec03a4$var$f(e));
                    break;
                }
                l.push(v);
            }
        }
        if (null != e.__c && null != e.__c.__H) {
            var b = e.__c.__H.__;
            if (b) for(var g = 0; g < b.length; g += 1){
                var E = b[g];
                if (E.__H) {
                    for(var k = 0; k < E.__H.length; k++)if ((t = E.__H[k]) != t) {
                        var I = $5cade3d0a6ec03a4$var$a(e);
                        throw new Error("Invalid argument passed to hook. Hooks should not be called with NaN in the dependency array. Hook index " + g + " in component " + I + " was called with NaN.");
                    }
                }
            }
        }
    };
}();

});
parcelRegister("4CmsM", function(module, exports) {

$parcel$export(module.exports, "options", () => $35cc22bdb201dfc1$export$41c562ebe57d11e2);
$parcel$export(module.exports, "createElement", () => $35cc22bdb201dfc1$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "createRef", () => $35cc22bdb201dfc1$export$7d1e3a5e95ceca43);
$parcel$export(module.exports, "Fragment", () => $35cc22bdb201dfc1$export$ffb0004e005737fa);
$parcel$export(module.exports, "Component", () => $35cc22bdb201dfc1$export$16fa2f45be04daa8);
$parcel$export(module.exports, "toChildArray", () => $35cc22bdb201dfc1$export$47e4c5b300681277);
$parcel$export(module.exports, "render", () => $35cc22bdb201dfc1$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "hydrate", () => $35cc22bdb201dfc1$export$fa8d919ba61d84db);
$parcel$export(module.exports, "cloneElement", () => $35cc22bdb201dfc1$export$e530037191fcd5d7);
$parcel$export(module.exports, "createContext", () => $35cc22bdb201dfc1$export$fd42f52fd3ae1109);
$parcel$export(module.exports, "h", () => $35cc22bdb201dfc1$export$c8a8987d4410bf2d);
var $35cc22bdb201dfc1$var$n, $35cc22bdb201dfc1$export$41c562ebe57d11e2, $35cc22bdb201dfc1$var$u, $35cc22bdb201dfc1$export$a8257692ac88316c, $35cc22bdb201dfc1$var$i, $35cc22bdb201dfc1$var$o, $35cc22bdb201dfc1$var$r, $35cc22bdb201dfc1$var$f, $35cc22bdb201dfc1$var$e, $35cc22bdb201dfc1$var$c, $35cc22bdb201dfc1$var$s, $35cc22bdb201dfc1$var$a, $35cc22bdb201dfc1$var$h = {}, $35cc22bdb201dfc1$var$p = [], $35cc22bdb201dfc1$var$v = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $35cc22bdb201dfc1$var$y = Array.isArray;
function $35cc22bdb201dfc1$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $35cc22bdb201dfc1$var$w(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $35cc22bdb201dfc1$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $35cc22bdb201dfc1$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $35cc22bdb201dfc1$var$g(l, f, i, o, null);
}
function $35cc22bdb201dfc1$var$g(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$35cc22bdb201dfc1$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $35cc22bdb201dfc1$export$41c562ebe57d11e2.vnode && $35cc22bdb201dfc1$export$41c562ebe57d11e2.vnode(f), f;
}
function $35cc22bdb201dfc1$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $35cc22bdb201dfc1$export$ffb0004e005737fa(n) {
    return n.children;
}
function $35cc22bdb201dfc1$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $35cc22bdb201dfc1$var$x(n, l) {
    if (null == l) return n.__ ? $35cc22bdb201dfc1$var$x(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $35cc22bdb201dfc1$var$x(n) : null;
}
function $35cc22bdb201dfc1$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $35cc22bdb201dfc1$var$C(n);
    }
}
function $35cc22bdb201dfc1$var$M(n) {
    (!n.__d && (n.__d = !0) && $35cc22bdb201dfc1$var$i.push(n) && !$35cc22bdb201dfc1$var$P.__r++ || $35cc22bdb201dfc1$var$o !== $35cc22bdb201dfc1$export$41c562ebe57d11e2.debounceRendering) && (($35cc22bdb201dfc1$var$o = $35cc22bdb201dfc1$export$41c562ebe57d11e2.debounceRendering) || $35cc22bdb201dfc1$var$r)($35cc22bdb201dfc1$var$P);
}
function $35cc22bdb201dfc1$var$P() {
    var n, u, t, o, r, e, c, s;
    for($35cc22bdb201dfc1$var$i.sort($35cc22bdb201dfc1$var$f); n = $35cc22bdb201dfc1$var$i.shift();)n.__d && (u = $35cc22bdb201dfc1$var$i.length, o = void 0, e = (r = (t = n).__v).__e, c = [], s = [], t.__P && ((o = $35cc22bdb201dfc1$var$d({}, r)).__v = r.__v + 1, $35cc22bdb201dfc1$export$41c562ebe57d11e2.vnode && $35cc22bdb201dfc1$export$41c562ebe57d11e2.vnode(o), $35cc22bdb201dfc1$var$O(t.__P, o, r, t.__n, t.__P.namespaceURI, 32 & r.__u ? [
        e
    ] : null, c, null == e ? $35cc22bdb201dfc1$var$x(r) : e, !!(32 & r.__u), s), o.__v = r.__v, o.__.__k[o.__i] = o, $35cc22bdb201dfc1$var$j(c, o, s), o.__e != e && $35cc22bdb201dfc1$var$C(o)), $35cc22bdb201dfc1$var$i.length > u && $35cc22bdb201dfc1$var$i.sort($35cc22bdb201dfc1$var$f));
    $35cc22bdb201dfc1$var$P.__r = 0;
}
function $35cc22bdb201dfc1$var$S(n, l, u, t, i, o, r, f, e, c, s) {
    var a, v, y, d, w, _ = t && t.__k || $35cc22bdb201dfc1$var$p, g = l.length;
    for(u.__d = e, $35cc22bdb201dfc1$var$$(u, l, _), e = u.__d, a = 0; a < g; a++)null != (y = u.__k[a]) && "boolean" != typeof y && "function" != typeof y && (v = -1 === y.__i ? $35cc22bdb201dfc1$var$h : _[y.__i] || $35cc22bdb201dfc1$var$h, y.__i = a, $35cc22bdb201dfc1$var$O(n, y, v, i, o, r, f, e, c, s), d = y.__e, y.ref && v.ref != y.ref && (v.ref && $35cc22bdb201dfc1$var$N(v.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), 65536 & y.__u || v.__k === y.__k ? e = $35cc22bdb201dfc1$var$I(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = w;
}
function $35cc22bdb201dfc1$var$$(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)r = t + a, null != (i = n.__k[t] = null == (i = l[t]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $35cc22bdb201dfc1$var$g(null, i, null, null, null) : $35cc22bdb201dfc1$var$y(i) ? $35cc22bdb201dfc1$var$g($35cc22bdb201dfc1$export$ffb0004e005737fa, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $35cc22bdb201dfc1$var$g(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = n, i.__b = n.__b + 1, f = $35cc22bdb201dfc1$var$L(i, u, r, s), i.__i = f, o = null, -1 !== f && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f == r - 1 ? a-- : f == r + 1 ? a++ : f > r ? s > e - r ? a += f - r : a-- : f < r && (f == r - a ? a -= f - r : a++), f !== t + a && (i.__u |= 65536))) : (o = u[r]) && null == o.key && o.__e && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $35cc22bdb201dfc1$var$x(o)), $35cc22bdb201dfc1$var$V(o, o, !1), u[r] = null, s--);
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $35cc22bdb201dfc1$var$x(o)), $35cc22bdb201dfc1$var$V(o, o));
}
function $35cc22bdb201dfc1$var$I(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $35cc22bdb201dfc1$var$I(t[i], l, u));
        return l;
    }
    n.__e != l && (l && n.type && !u.contains(l) && (l = $35cc22bdb201dfc1$var$x(n)), u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $35cc22bdb201dfc1$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($35cc22bdb201dfc1$var$y(n) ? n.some(function(n) {
        $35cc22bdb201dfc1$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $35cc22bdb201dfc1$var$L(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type && 0 == (131072 & e.__u)) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $35cc22bdb201dfc1$var$T(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $35cc22bdb201dfc1$var$v.test(l) ? u : u + "px";
}
function $35cc22bdb201dfc1$var$A(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $35cc22bdb201dfc1$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $35cc22bdb201dfc1$var$T(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n || "onFocusOut" === l || "onFocusIn" === l ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = $35cc22bdb201dfc1$var$e, n.addEventListener(l, o ? $35cc22bdb201dfc1$var$s : $35cc22bdb201dfc1$var$c, o)) : n.removeEventListener(l, o ? $35cc22bdb201dfc1$var$s : $35cc22bdb201dfc1$var$c, o);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $35cc22bdb201dfc1$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $35cc22bdb201dfc1$var$e++;
            else if (u.t < t.u) return;
            return t($35cc22bdb201dfc1$export$41c562ebe57d11e2.event ? $35cc22bdb201dfc1$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $35cc22bdb201dfc1$var$O(n, u, t, i, o, r, f, e, c, s) {
    var a, h, p, v, w, _, g, m, x, C, M, P, $, I, H, L, T = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $35cc22bdb201dfc1$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof T) try {
        if (m = u.props, x = "prototype" in T && T.prototype.render, C = (a = T.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? g = (h = u.__c = t.__c).__ = h.__E : (x ? u.__c = h = new T(m, M) : (u.__c = h = new $35cc22bdb201dfc1$export$16fa2f45be04daa8(m, M), h.constructor = T, h.render = $35cc22bdb201dfc1$var$q), C && C.sub(h), h.props = m, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), x && null == h.__s && (h.__s = h.state), x && null != T.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $35cc22bdb201dfc1$var$d({}, h.__s)), $35cc22bdb201dfc1$var$d(h.__s, T.getDerivedStateFromProps(m, h.__s))), v = h.props, w = h.state, h.__v = u, p) x && null == T.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), x && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (x && null == T.getDerivedStateFromProps && m !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, M), !h.__e && (null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, M) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (h.props = m, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), P = 0; P < h._sb.length; P++)h.__h.push(h._sb[P]);
                h._sb = [], h.__h.length && f.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, M), x && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, w, _);
            });
        }
        if (h.context = M, h.props = m, h.__P = n, h.__e = !1, $ = $35cc22bdb201dfc1$export$41c562ebe57d11e2.__r, I = 0, x) {
            for(h.state = h.__s, h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++I < 25);
        h.state = h.__s, null != h.getChildContext && (i = $35cc22bdb201dfc1$var$d($35cc22bdb201dfc1$var$d({}, i), h.getChildContext())), x && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, w)), $35cc22bdb201dfc1$var$S(n, $35cc22bdb201dfc1$var$y(L = null != a && a.type === $35cc22bdb201dfc1$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? L : [
            L
        ], u, t, i, o, r, f, e, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && f.push(h), g && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != r) {
            for(u.__u |= c ? 160 : 32; e && 8 === e.nodeType && e.nextSibling;)e = e.nextSibling;
            r[r.indexOf(e)] = null, u.__e = e;
        } else u.__e = t.__e, u.__k = t.__k;
        $35cc22bdb201dfc1$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $35cc22bdb201dfc1$var$z(t.__e, u, t, i, o, r, f, c, s);
    (a = $35cc22bdb201dfc1$export$41c562ebe57d11e2.diffed) && a(u);
}
function $35cc22bdb201dfc1$var$j(n, u, t) {
    u.__d = void 0;
    for(var i = 0; i < t.length; i++)$35cc22bdb201dfc1$var$N(t[i], t[++i], t[++i]);
    $35cc22bdb201dfc1$export$41c562ebe57d11e2.__c && $35cc22bdb201dfc1$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $35cc22bdb201dfc1$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $35cc22bdb201dfc1$var$z(l, u, t, i, o, r, f, e, c) {
    var s, a, p, v, d, _, g, m = t.props, k = u.props, b = u.type;
    if ("svg" === b ? o = "http://www.w3.org/2000/svg" : "math" === b ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != r) {
        for(s = 0; s < r.length; s++)if ((d = r[s]) && "setAttribute" in d == !!b && (b ? d.localName === b : 3 === d.nodeType)) {
            l = d, r[s] = null;
            break;
        }
    }
    if (null == l) {
        if (null === b) return document.createTextNode(k);
        l = document.createElementNS(o, b, k.is && k), r = null, e = !1;
    }
    if (null === b) m === k || e && l.data === k || (l.data = k);
    else {
        if (r = r && $35cc22bdb201dfc1$var$n.call(l.childNodes), m = t.props || $35cc22bdb201dfc1$var$h, !e && null != r) for(m = {}, s = 0; s < l.attributes.length; s++)m[(d = l.attributes[s]).name] = d.value;
        for(s in m)if (d = m[s], "children" == s) ;
        else if ("dangerouslySetInnerHTML" == s) p = d;
        else if ("key" !== s && !(s in k)) {
            if ("value" == s && "defaultValue" in k || "checked" == s && "defaultChecked" in k) continue;
            $35cc22bdb201dfc1$var$A(l, s, null, d, o);
        }
        for(s in k)d = k[s], "children" == s ? v = d : "dangerouslySetInnerHTML" == s ? a = d : "value" == s ? _ = d : "checked" == s ? g = d : "key" === s || e && "function" != typeof d || m[s] === d || $35cc22bdb201dfc1$var$A(l, s, d, m[s], o);
        if (a) e || p && (a.__html === p.__html || a.__html === l.innerHTML) || (l.innerHTML = a.__html), u.__k = [];
        else if (p && (l.innerHTML = ""), $35cc22bdb201dfc1$var$S(l, $35cc22bdb201dfc1$var$y(v) ? v : [
            v
        ], u, t, i, "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : o, r, f, r ? r[0] : t.__k && $35cc22bdb201dfc1$var$x(t, 0), e, c), null != r) for(s = r.length; s--;)null != r[s] && $35cc22bdb201dfc1$var$w(r[s]);
        e || (s = "value", void 0 !== _ && (_ !== l[s] || "progress" === b && !_ || "option" === b && _ !== m[s]) && $35cc22bdb201dfc1$var$A(l, s, _, m[s], o), s = "checked", void 0 !== g && g !== l[s] && $35cc22bdb201dfc1$var$A(l, s, g, m[s], o));
    }
    return l;
}
function $35cc22bdb201dfc1$var$N(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $35cc22bdb201dfc1$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $35cc22bdb201dfc1$var$V(n, u, t) {
    var i, o;
    if ($35cc22bdb201dfc1$export$41c562ebe57d11e2.unmount && $35cc22bdb201dfc1$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $35cc22bdb201dfc1$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $35cc22bdb201dfc1$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $35cc22bdb201dfc1$var$V(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || $35cc22bdb201dfc1$var$w(n.__e), n.__c = n.__ = n.__e = n.__d = void 0;
}
function $35cc22bdb201dfc1$var$q(n, l, u) {
    return this.constructor(n, u);
}
function $35cc22bdb201dfc1$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $35cc22bdb201dfc1$export$41c562ebe57d11e2.__ && $35cc22bdb201dfc1$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $35cc22bdb201dfc1$var$O(t, u = (!o && i || t).__k = $35cc22bdb201dfc1$export$c8a8987d4410bf2d($35cc22bdb201dfc1$export$ffb0004e005737fa, null, [
        u
    ]), r || $35cc22bdb201dfc1$var$h, $35cc22bdb201dfc1$var$h, t.namespaceURI, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $35cc22bdb201dfc1$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), $35cc22bdb201dfc1$var$j(f, u, e);
}
function $35cc22bdb201dfc1$export$fa8d919ba61d84db(n, l) {
    $35cc22bdb201dfc1$export$b3890eb0ae9dca99(n, l, $35cc22bdb201dfc1$export$fa8d919ba61d84db);
}
function $35cc22bdb201dfc1$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $35cc22bdb201dfc1$var$d({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $35cc22bdb201dfc1$var$n.call(arguments, 2) : t), $35cc22bdb201dfc1$var$g(l.type, e, i || l.key, o || l.ref, null);
}
function $35cc22bdb201dfc1$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $35cc22bdb201dfc1$var$a++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.componentWillUnmount = function() {
                u = null;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $35cc22bdb201dfc1$var$M(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u && u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$35cc22bdb201dfc1$var$n = $35cc22bdb201dfc1$var$p.slice, $35cc22bdb201dfc1$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $35cc22bdb201dfc1$var$u = 0, $35cc22bdb201dfc1$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $35cc22bdb201dfc1$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $35cc22bdb201dfc1$var$d({}, this.state), "function" == typeof n && (n = n($35cc22bdb201dfc1$var$d({}, u), this.props)), n && $35cc22bdb201dfc1$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $35cc22bdb201dfc1$var$M(this));
}, $35cc22bdb201dfc1$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $35cc22bdb201dfc1$var$M(this));
}, $35cc22bdb201dfc1$export$16fa2f45be04daa8.prototype.render = $35cc22bdb201dfc1$export$ffb0004e005737fa, $35cc22bdb201dfc1$var$i = [], $35cc22bdb201dfc1$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $35cc22bdb201dfc1$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $35cc22bdb201dfc1$var$P.__r = 0, $35cc22bdb201dfc1$var$e = 0, $35cc22bdb201dfc1$var$c = $35cc22bdb201dfc1$var$F(!1), $35cc22bdb201dfc1$var$s = $35cc22bdb201dfc1$var$F(!0), $35cc22bdb201dfc1$var$a = 0;

});

parcelRegister("8wPBw", function(module, exports) {

var $4CmsM = parcelRequire("4CmsM");
var $63595768d8deaad6$var$i;
function $63595768d8deaad6$export$427ce13b63e52247(o, e) {
    return (0, $4CmsM.options).__a && (0, $4CmsM.options).__a(e), o;
}
null != ($63595768d8deaad6$var$i = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0) && $63595768d8deaad6$var$i.__PREACT_DEVTOOLS__ && $63595768d8deaad6$var$i.__PREACT_DEVTOOLS__.attachPreact("10.23.2", (0, $4CmsM.options), {
    Fragment: (0, $4CmsM.Fragment),
    Component: (0, $4CmsM.Component)
});

});


parcelRegister("dzPbc", function(module, exports) {
module.exports = new URL("Capture_it.9e45797c.ttf", import.meta.url).toString();

});

parcelRegister("kv3xU", function(module, exports) {
module.exports = new URL("service-worker.js", import.meta.url).toString();

});

parcelRegister("6FHsx", function(module, exports) {

var $Apt1V = parcelRequire("Apt1V");
module.exports = $Apt1V("3ibp0").then(()=>parcelRequire("03qT7"));

});


var $1a2c0d4443bdc001$exports = {};

var $eyg9v = parcelRequire("eyg9v");
const $1a2c0d4443bdc001$export$a716cf793ad7f839 = "08/28/2026 06:18:15 AM";
const $1a2c0d4443bdc001$export$59b5344f0ddeca73 = "168";
const $1a2c0d4443bdc001$export$862627d4c720c7b9 = "v1.1.31-web";
(0, $eyg9v._register)($1a2c0d4443bdc001$export$a716cf793ad7f839, $1a2c0d4443bdc001$export$59b5344f0ddeca73, $1a2c0d4443bdc001$export$862627d4c720c7b9);

var $722db67a65ed2eaa$exports = {};

(parcelRequire("lmaeY")).register(new URL("", import.meta.url).toString(), JSON.parse('["9DwS7","index.a3ec4553.js","2DXiy","web.49a89592.js","4Wuru","Capture_it.9e45797c.ttf","99rdy","service-worker.js","3ibp0","frontend.8a513262.js","5CdgX","classic.8701d919.png","lqZDZ","i1.add52e1e.png","ctPaU","cardboard.16f21024.png","gQ4dY","wooden.566697c8.png","3LJCc","root.641cbbbb.js","kG1PD","classic.ae7d88ae.js","cjCmU","wooden.4b39fc6b.js","8X92n","i1.5eedcac4.js","9fjoV","cardboard.4f3ba67b.js","7l1qT","microban.d87ff3b2.js","1jnwV","microban ii.d267237b.js","c1ICI","microban iii.25e698df.js","cAewD","microban iv.bc7dc62d.js","c1w8W","tutorial.04b28ccb.js","5sllw","GetItOnGooglePlay_Badge_Web_color_English.8c38fcaa.svg","4CeGc","lagerhaus.cc8a9040.webp"]'));


parcelRequire("9I1gl");

//# sourceMappingURL=index.a3ec4553.js.map
